// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_nw-0";